/**
 * Saves client details.
 */
var handleError = function (err) {
    console.log(err);
    return new Response(JSON.stringify({
      code: 400,
      message: 'Stupid network Error'
    }));
  };

export default function updateClientStatus(client, sDispatch) {

    const abortController = new AbortController();

    const request = {   
        companyid:client.companyID,
        status:client.status,
    };

    let mounted = true;
    (async () => {  
        const res = await fetch(process.env.REACT_APP_FIND_API+'/find/client/status', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(request),
        signal: abortController.signal,
        }).catch(handleError);
        const data = await res.json();
        if (mounted) {
            if (data.status === "success"){
                sDispatch({
                  type: "setClientList",
                  payload: { clientList: data.clients }
                });
            }
        }
        const cleanup = () => {
            mounted = false;
            abortController.abort();
        };
        return cleanup;
    
    })();

}
